/* global ajax */

jQuery( $ => {
    $( '.testimonials-grid-more' ).on( 'click', async function() {
        const chevron = $( this ).children( '.chevron' );
        const spinner = $( this ).children( '.spinner' );

        chevron.hide();
        spinner.show();

        const pagination = $( this ).closest( '.testimonials-grid-pagination' );
        const nonceField = pagination.children( 'input[name="grid-nonce"]' );
        const postIdField = pagination.children( 'input[name="grid-post-id"]' );
        const currentPageField = pagination.children( 'input[name="grid-current-page"]' );

        const nonce = nonceField.val();
        const postID = parseInt( postIdField.val() );
        const currentPage = parseInt( currentPageField.val() );

        const nextPage = currentPage + 1;

        currentPageField.val( nextPage );

        const data = new FormData();
        data.append( 'action', 'xdte_grid_show_more' );
        data.append( 'nonce', nonce );
        data.append( 'page', nextPage );
        data.append( 'post_id', postID );

        const responseJSON = await fetch( ajax.ajaxURL, {
            method: 'POST',
            body: data,
        } );

        const response = await responseJSON.json();

        if ( response.has_posts ) {
            const grid = pagination.siblings( '.testimonials-grid' );
            grid.append( response.html );

            if ( response.max_num_pages === nextPage ) {
                $( this ).prop( 'disabled', true );
            }
        }

        chevron.show();
        spinner.hide();
    } );
} );
